module.exports = {"341122100":"新安镇","341122101":"半塔镇","341122102":"水口镇","341122103":"汊河镇","341122104":"大英镇","341122105":"雷官镇","341122106":"施官镇","341122107":"舜山镇","341122108":"三城镇","341122109":"独山镇","341122110":"张山镇","341122203":"杨郢乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341122.json
// module id = 1112
// module chunks = 0